import styled from 'styled-components';
import { Modal } from 'antd';

const StyledDataBooksModal = styled(Modal)`
    .ant-modal-body {
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .ant-modal-content {
        box-shadow: none;
        background-color: ${global.White};
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        display: flex;
        justify-content: center;
    }
`;

export default StyledDataBooksModal;
